import * as apiClient from "./apiClient";

export async function getLeads(params = {}) {
  const res = await apiClient.get("/api/contacts", { query: params });
  return apiClient.unwrapData(res) || { items: [] };
}

export async function createLead(payload) {
  const res = await apiClient.post("/api/contacts", { body: payload });
  return apiClient.unwrapData(res);
}

export async function updateLead(leadId, payload) {
  const res = await apiClient.put(`/api/contacts/${leadId}`, { body: payload });
  return apiClient.unwrapData(res);
}

export async function deleteLead(leadId) {
  const res = await apiClient.del(`/api/contacts/${leadId}`);
  return apiClient.unwrapData(res);
}

export async function importLeads(formData) {
  const res = await apiClient.upload("/api/contacts/import", { formData });
  const data = apiClient.unwrapData(res) || {};
  return {
    ...data,
    added: Number(data.created || 0) + Number(data.existing || 0),
  };
}

export async function assignLeadsToGroups(payload) {
  const leadIds = payload.lead_ids || payload.contact_ids || [];
  const groupIds = payload.group_ids || [];

  await Promise.all(
    groupIds.map((groupId) =>
      apiClient.post(`/api/contact-groups/${groupId}/contacts`, {
        body: { contact_ids: leadIds },
      })
    )
  );

  return {
    assigned: leadIds.length,
    groups: groupIds.length,
  };
}

export async function removeLeadFromGroup(leadId, groupId) {
  const res = await apiClient.del(`/api/contact-groups/${groupId}/contacts/${leadId}`);
  return apiClient.unwrapData(res);
}
